import { useTranslation } from "react-i18next";

import type { Progress } from "../../configs/apis/GetProgress/models";
import type { MilestonePrize } from "../../configs/apis/models";
import { LIMIT_TO_SEE_ALL } from "../../configs/models/constants";
import { getActiveMilestonePrize } from "../../configs/utils/utility";
import type { ChallengeVariant } from "../Cards/ChallengeCard";
import ChallengeCard from "../Cards/ChallengeCard";
import Skeleton from "../Common/Skeleton";
import SectionLayout from "../Layouts/SectionLayout";

type SliderProps = {
  claimingChallengeId?: number;
  content: Progress[];
  isClaiming: boolean;
  isLoading: boolean;
  onClaim: (challengeId?: number, reward?: MilestonePrize | undefined) => void;
  count: number;
};

const Slider = ({ claimingChallengeId, content, count, isClaiming, isLoading, onClaim }: SliderProps) => {
  const { t: translate } = useTranslation("translation");

  const getVariant = (card: Progress): ChallengeVariant => {
    if (card?.prizes.length !== 0) return "claimable";
    return "inProgress";
  };

  return (
    <SectionLayout
      count={count}
      hasSeeAll={count > LIMIT_TO_SEE_ALL}
      title={translate("in_progress")}
      to="/gamification/all-in-progress"
    >
      {isLoading
        ? Array.from({ length: 4 }).map((_, idx) => <Skeleton key={idx} />)
        : content?.map((slide) => {
          const activePrize = getActiveMilestonePrize(slide?.prizes);

          return (
            <ChallengeCard
              {...slide}
              categoryName={slide?.category?.name || ""}
              isClaimingThis={isClaiming && claimingChallengeId === slide.id}
              key={slide.id}
              onClaim={() => onClaim(slide.id, activePrize)}
              prize={activePrize}
              progress={slide?.averageProgress}
              skipImmediateClaim={true}
              variant={getVariant(slide)}
            />
          );
        })}
    </SectionLayout>
  );
};

export default Slider;
